import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { spacing } from '../../constants/designTokens';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * CollapsibleSection Component
 *
 * A collapsible container for grouping related controls.
 * Includes a header with title, icon, and chevron that toggles expansion.
 */
const CollapsibleSection = ({ title, icon: Icon, children, defaultExpanded = false }) => {
  const { colors } = useTheme();
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{ marginBottom: spacing.xl }}>
      {/* Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: 'calc(100% + 16px)',
          marginLeft: '-8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: `${spacing.sm} ${spacing.sm}`,
          background: 'transparent',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          outline: 'none',
          marginBottom: isExpanded ? spacing.md : 0,
          transition: 'background 0.15s ease'
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.sm
        }}>
          {Icon && (
            <Icon
              size={16}
              style={{
                color: isExpanded || isHovered ? colors.foreground : colors.foregroundSecondary,
                transition: 'color 0.15s ease'
              }}
            />
          )}
          <span style={{
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: isExpanded || isHovered ? colors.foreground : colors.foregroundSecondary,
            transition: 'color 0.15s ease'
          }}>
            {title}
          </span>
        </div>
        <ChevronDown
          size={16}
          style={{
            color: isHovered ? colors.foreground : colors.foregroundSecondary,
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'all 0.15s ease'
          }}
        />
      </button>

      {/* Content */}
      <div
        style={{
          display: isExpanded ? 'block' : 'none',
          animation: isExpanded ? 'fadeIn 0.2s ease-in' : 'none'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleSection;
